import { Utility } from '@app/models/utility';
import { Component, Input, OnInit } from '@angular/core';
import { RequestApproveSet } from '../request-approve/request-approve-datasource';

export interface StampSet {
  stampStr: string;
  stamp: Date; // ソートに必要
  ejectFlag: boolean;
  isNew: boolean;
}

@Component({
  selector: 'app-change-stamp-table',
  templateUrl: './change-stamp-table.component.html',
  styleUrls: ['./change-stamp-table.component.css']
})
export class ChangeStampTableComponent implements OnInit {
  @Input() reportRecord: RequestApproveSet;

  targetDate: Date;
  dateDiff: Array<string> = ['前','','翌'];
  arriveStamps: Array<StampSet> = [];
  leaveStamps: Array<StampSet> = [];
  temporaryLeaveStamps: Array<StampSet> = [];
  reenterStamps: Array<StampSet> = [];
  indexArr: Array<number> = [];

  constructor() { }

  ngOnInit(): void {

    this.targetDate = this.reportRecord.targetDate;

    this.reportRecord.actualTimeStamps.forEach((stamp, index) => {
      if (stamp) {
        const stampDate = Utility.createDateFromText(stamp);
        const dateDiffIndex = Utility.diffDay(this.targetDate,stampDate) + 1;
        if (index === 0) {
          // 出社
          this.arriveStamps.push({
            stampStr: this.dateDiff[dateDiffIndex] + Utility.convertDateToMinite(stampDate),
            stamp: stampDate,
            ejectFlag: false,
            isNew: false
          });
        } else if (index === 1) {
          // 退社
          this.leaveStamps.push({
            stampStr: this.dateDiff[dateDiffIndex] + Utility.convertDateToMinite(stampDate),
            stamp: stampDate,
            ejectFlag: false,
            isNew: false
          });
        } else if (index % 2 === 0) {
          // 外出
          this.temporaryLeaveStamps.push({
            stampStr: this.dateDiff[dateDiffIndex] + Utility.convertDateToMinite(stampDate),
            stamp: stampDate,
            ejectFlag: false,
            isNew: false
          });
        } else if (index % 2 === 1) {
          // 戻り
          this.reenterStamps.push({
            stampStr: this.dateDiff[dateDiffIndex] + Utility.convertDateToMinite(stampDate),
            stamp: stampDate,
            ejectFlag: false,
            isNew: false
          });
        }
      }
    });

    this.reportRecord.ejectFlags.forEach((e,index) => {
      if(e) {
        if (index === 0 || index === 1) {
          // 出社・退社の打刻取消は無い
        } else if (index % 2 === 0) {
          // 外出
          if (this.temporaryLeaveStamps[(index - 2) / 2]) {
            this.temporaryLeaveStamps[(index - 2) / 2].ejectFlag = true;
          }
        } else if (index % 2 === 1) {
          // 戻り
          if (this.reenterStamps[(index - 3) / 2]) {
            this.reenterStamps[(index - 3) / 2].ejectFlag = true;
          }
        }
      }
    });

    this.reportRecord.changeTimeStamps.forEach((stamp,index) => {
      if(stamp) {
        const dateDiffIndex = Utility.diffDay(this.targetDate,stamp) + 1;
        if (index === 0) {
          // 出社
          if (this.arriveStamps.length === 1) {
            this.arriveStamps[0].ejectFlag = true;
          }
          this.arriveStamps.push({
            stampStr: this.dateDiff[dateDiffIndex] + Utility.convertDateToMinite(stamp),
            stamp: stamp,
            ejectFlag: false,
            isNew: true
          });
        } else if (index === 1) {
          // 退社
          if (this.leaveStamps.length === 1) {
            this.leaveStamps[0].ejectFlag = true;
          }
          this.leaveStamps.push({
            stampStr: this.dateDiff[dateDiffIndex] + Utility.convertDateToMinite(stamp),
            stamp: stamp,
            ejectFlag: false,
            isNew: true
          });
        } else if (index % 2 === 0) {
          // 外出
          this.temporaryLeaveStamps.push({
            stampStr: this.dateDiff[dateDiffIndex] + Utility.convertDateToMinite(stamp),
            stamp: stamp,
            ejectFlag: false,
            isNew: true
          });
        } else if (index % 2 === 1) {
          // 戻り
          this.reenterStamps.push({
            stampStr: this.dateDiff[dateDiffIndex] + Utility.convertDateToMinite(stamp),
            stamp: stamp,
            ejectFlag: false,
            isNew: true
          });
        }
      }
    })

    this.temporaryLeaveStamps.sort((a,b) => a.stamp.getTime() - b.stamp.getTime());
    this.reenterStamps.sort((a,b) => a.stamp.getTime() - b.stamp.getTime());

    // 見映えの為に最低4行は表示する。
    const maxLength = Math.max(...[this.arriveStamps.length, this.leaveStamps.length, this.temporaryLeaveStamps.length, this.reenterStamps.length]);
    this.indexArr = [...Array(maxLength)].map((_: undefined, index: number) => index);

  }

}
